var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "교육 문제풀이 SET 정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && _vm.popupParam.disableEidt
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.question,
                                  mappingType: _vm.mappingType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable:
                              _vm.editable && _vm.popupParam.disableEidt,
                            label: "교육 문제풀이 SET명",
                            name: "eduQuestionMstName",
                          },
                          model: {
                            value: _vm.question.eduQuestionMstName,
                            callback: function ($$v) {
                              _vm.$set(_vm.question, "eduQuestionMstName", $$v)
                            },
                            expression: "question.eduQuestionMstName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            required: "",
                            editable:
                              _vm.editable && _vm.popupParam.disableEidt,
                            type: "edit",
                            codeGroupCd: "EDU_KIND_FST_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "educationKindCdLarge",
                            label: "교육종류",
                          },
                          model: {
                            value: _vm.question.educationKindCdLarge,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.question,
                                "educationKindCdLarge",
                                $$v
                              )
                            },
                            expression: "question.educationKindCdLarge",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable:
                              _vm.editable && _vm.popupParam.disableEidt,
                            isFlag: true,
                            label: "LBLUSEFLAG",
                            name: "useFlag",
                          },
                          model: {
                            value: _vm.question.useFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.question, "useFlag", $$v)
                            },
                            expression: "question.useFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c(
                          "c-table",
                          {
                            ref: "questionGrid",
                            attrs: {
                              title: "문제",
                              columnSetting: false,
                              isFullScreen: false,
                              usePaging: false,
                              filtering: false,
                              columns: _vm.questionGrid.columns,
                              isExcelDown: false,
                              data: _vm.question.questions,
                              gridHeight: "600px",
                              selection: "multiple",
                              rowKey: "eduQuestionId",
                              editable:
                                _vm.editable && _vm.popupParam.disableEidt,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "customArea",
                                fn: function ({ props }) {
                                  return [
                                    [
                                      _c(
                                        "q-chip",
                                        {
                                          staticStyle: {
                                            "margin-top": "3px !important",
                                          },
                                          attrs: {
                                            clickable: "",
                                            outline: "",
                                            square: "",
                                            color: "blue",
                                            "text-color": "white",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getAnswerList(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" ▶ ")]
                                      ),
                                    ],
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c(
                              "template",
                              { slot: "table-button" },
                              [
                                _c(
                                  "q-btn-group",
                                  { attrs: { outline: "" } },
                                  [
                                    _vm.editable && _vm.popupParam.disableEidt
                                      ? _c("c-btn", {
                                          attrs: {
                                            label: "LBLADD",
                                            icon: "add",
                                          },
                                          on: { btnClicked: _vm.addQuestion },
                                        })
                                      : _vm._e(),
                                    _vm.editable &&
                                    _vm.popupParam.disableEidt &&
                                    _vm.question.questions.length > 0
                                      ? _c("c-btn", {
                                          attrs: {
                                            label: "제외",
                                            icon: "remove",
                                          },
                                          on: {
                                            btnClicked: _vm.removeQuestion,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c(
                          "c-table",
                          {
                            ref: "answerGrid",
                            attrs: {
                              title: "답변",
                              columnSetting: false,
                              isFullScreen: false,
                              usePaging: false,
                              filtering: false,
                              columns: _vm.answerGrid.columns,
                              isExcelDown: false,
                              data: _vm.row.answers,
                              gridHeight: "600px",
                              selection: "multiple",
                              rowKey: "eduAnswerId",
                              editable:
                                _vm.editable && _vm.popupParam.disableEidt,
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "table-chip" },
                              [
                                _c(
                                  "q-btn-group",
                                  { attrs: { outline: "" } },
                                  [
                                    _vm.selectedQuestionName
                                      ? _c(
                                          "q-chip",
                                          {
                                            attrs: { outline: "", square: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.selectedQuestionName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "template",
                              { slot: "table-button" },
                              [
                                _c(
                                  "q-btn-group",
                                  { attrs: { outline: "" } },
                                  [
                                    _vm.editable &&
                                    _vm.popupParam.disableEidt &&
                                    _vm.selectedQuestionId
                                      ? _c("c-btn", {
                                          attrs: {
                                            label: "LBLADD",
                                            icon: "add",
                                          },
                                          on: { btnClicked: _vm.addAnswer },
                                        })
                                      : _vm._e(),
                                    _vm.editable &&
                                    _vm.popupParam.disableEidt &&
                                    _vm.selectedQuestionId &&
                                    _vm.row.answers.length > 0
                                      ? _c("c-btn", {
                                          attrs: {
                                            label: "제외",
                                            icon: "remove",
                                          },
                                          on: { btnClicked: _vm.removeAnswer },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }